import React, { useState } from 'react'
import { Group, NumberInput, Pagination, Text } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'

import { formatNumberToThousands } from 'utils'

export type TableFooterProps = {
  totalCount?: number
  page: number
  totalPages: number
  onPageChange: (page: number) => void
}

export const TableFooter = (props: TableFooterProps) => {
  const { t } = useTranslation('common')
  const { page, totalPages, totalCount, onPageChange } = props
  const [jumpValue, setJumpValue] = useState<number | ''>('')

  const handleJump = () => {
    if (typeof jumpValue !== 'number') return
    const target = Math.min(Math.max(1, Math.floor(jumpValue)), totalPages)
    if (target !== page) onPageChange(target)
    setJumpValue('')
  }

  return (
    <Group align="center" position="apart" px="lg" pb="sm">
      {totalPages > 1 && (
        <Group spacing="lg" align="center">
          <Pagination
            siblings={1}
            boundaries={2}
            size="xs"
            spacing="xs"
            value={page}
            onChange={onPageChange}
            total={totalPages}
          />
          <Group spacing={4} align="center">
            <Text size="xs" color="dimmed">
              {t('common:grid.jumpToPagePrefix')}
            </Text>
            <NumberInput
              size="xs"
              hideControls
              precision={0}
              min={1}
              max={totalPages}
              value={jumpValue}
              onChange={setJumpValue}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  event.preventDefault()
                  handleJump()
                }
              }}
              styles={{ input: { width: 48, textAlign: 'center', paddingLeft: 4, paddingRight: 4 } }}
            />
            <Text size="xs" color="dimmed">
              {t('common:grid.jumpToPageSuffix')}
            </Text>
          </Group>
        </Group>
      )}
      <Text color="dimmed" size="xs">
        {t('common:grid.totalCount', { total: totalCount ? formatNumberToThousands(totalCount) : '-' })}
      </Text>
    </Group>
  )
}
